import { render, staticRenderFns } from "./auditRejectReason.vue?vue&type=template&id=34aed881&scoped=true"
import script from "./auditRejectReason.vue?vue&type=script&lang=js"
export * from "./auditRejectReason.vue?vue&type=script&lang=js"
import style0 from "./auditRejectReason.vue?vue&type=style&index=0&id=34aed881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aed881",
  null
  
)

export default component.exports